<template>
  <div>
    <div :class="hasResults ? 'd-flex' : 'd-none'" class="flex-wrap">
      <div class="breadcrumbs d-flex pa-0 col-12">
        <div>
          <v-btn
            class="mt-3 mb-4 mr-2"
            fab
            dark
            x-small
            color="primary"
            @click="changeSideBar()"
          >
            <v-icon dark>
              {{ hideSidebar ? "mdi-forwardburger" : "mdi-backburger" }}
            </v-icon>
          </v-btn>
          <v-expand-x-transition>
            <div v-show="!hideSidebar" class="sidebar">
              <ais-panel v-for="(facet, index) in facets" :key="index">
                <v-card elevation="1" class="transport" style="width: 100%" flat tile>
                  <v-card-actions>
                    <h4 class="pl-4 subtitle-2">{{ facet.label }}</h4>
                    <v-spacer />
                    <v-btn icon @click="facet.show = !facet.show">
                      <v-icon>
                        {{
                          facet.show ? "mdi-chevron-up" : "mdi-chevron-down"
                        }}
                      </v-icon>
                    </v-btn>
                  </v-card-actions>
                  <v-divider />
                  <v-expand-transition>
                    <div v-show="facet.show">
                      <div class="grey lighten-4 pa-4">
                        <component
                          :is="'ais-' + facet.facetType"
                          :name="facet.attribute"
                          :class-names="classNames('ais-' + facet.facetType)"
                          :attribute="facet.attribute"
                          v-bind="facet.facetSettings"
                          :transform-items="facet.attribute === 'country' ? transformItemsCountry : transformItems"
                        >
                          <span slot="showMoreLabel" slot-scope="{ isShowingMore }">
                            {{ !isShowingMore ? "voir plus" : "voir moins" }}
                          </span>
                        </component>
                      </div>
                      <v-divider />
                    </div>
                  </v-expand-transition>
                </v-card>
              </ais-panel>
            </div>
          </v-expand-x-transition>
        </div>
        <div class="content pl-4 flex-wrap col py-0">
          <div class="pt-2 d-flex ">
            <div :class="resultsLabel ? 'ais-CurrentRefinements' : 'my-1'">
              <v-chip
                v-if="resultsLabel"
                label
                small
                class="my-2 ml-2"
              >
                {{ resultsLabel }}
              </v-chip>
            </div>
            <a
              v-if="countAdvancedFilters"
              @click="showAdvancedSearch()"
            >recherche avancés ({{ countAdvancedFilters }})</a>
            <ais-current-refinements
              :transform-items="transformItems"
            >
              <!-- eslint-enbale -->
              <template slot-scope="{ items }">
                <div
                  v-for="item in items"
                  :key="item.attribute"
                  class="d-inline-block"
                >
                  <v-chip
                    v-for="(refinement, index) in item.refinements"
                    :key="index"
                    label
                    small
                    class="ma-2 white--text"
                    close
                    color="red"
                    @click:close="
                      state.helper.setPage(0);
                      item.refine(refinement);
                    "
                  >
                    <span><strong>{{ item.label }}:</strong>
                      {{ refinement.label }}</span>
                  </v-chip>
                </div>
              </template>
            </ais-current-refinements>
            <div class="d-inline-block ml-2">
              <ais-clear-refinements
                v-show="state && state.nbHits > 0"
                :class-names="{
                  'ais-ClearRefinements-button':
                    'ais-ClearRefinements-button-custom',
                }"
              >
                <div slot="resetLabel" class="d-flex align-center">
                  <v-icon class="pa-0" small>mdi-close-circle-outline</v-icon><span class="ml-1 caption">effacer tout</span>
                </div>
              </ais-clear-refinements>
            </div>
          </div>

          <v-card>
            <!--  <ais-hits :escapeHTML="false" /> -->
            <v-card-title class="py-2">
              <v-btn small class="" outlined @click="newCustomer()">
                <v-icon>mdi-account-plus</v-icon>
                <span class="ml-2 d-none d-sm-inline-block">Nouveau Client</span>
              </v-btn>

              <v-spacer />
              <ais-stats class="d-inline-block">
                <span slot-scope="{ nbHits }" class="caption">Nombre de résultats : {{ nbHits }}</span>
              </ais-stats>
            </v-card-title>
            <div class="results">
              <v-divider />
              <div v-if="state && !state.isLoading">
                <v-data-table
                  :headers="headers"
                  :items="state.items"
                  :items-per-page="10"
                  hide-default-footer
                  class="elevation-1 pointer"
                  @click:row="clickUser"
                  @contextmenu:row="rightClickUser"
                >
                  <template #item.digital_account="{ item }">
                    <v-switch
                      readonly
                      inset
                      :input-value="item.digital_account"
                    />
                  </template>
                  <template #item.payeur="{ item }">
                    <v-switch
                      readonly
                      inset
                      :input-value="isCustomerPayeur(item)"
                    />
                  </template>
                  <template v-if="isReturnToPegase" #item.exportToPegase="{ item }">
                    <v-checkbox v-model="selectedCustomer[item.uuid]" @click="customerSelected($event, item)" />
                  </template>
                  <template v-if="isReturnToHello" #item.exportToHello="{ item }">
                    <v-checkbox v-model="selectedCustomer[item.uuid]" @click="customerSelected($event, item)" />
                  </template>
                  <template #item.nom="{ item }">
                    <span>{{ item.firstname }}</span>
                    <span> {{ item.lastname }}</span>
                  </template>
                  <template #item.address="{ item }">
                    <div>{{ item.street_number }} {{ item.street_name }}</div>
                    <div>{{ item.zip_code }}</div>
                    <div>{{ item.town }} {{ getCountryLabel(item.country) }}</div>
                  </template>
                  <template #item.birth_date="{ item }">
                    <span>{{ item.birth_date }}</span>
                  </template>
                  <template #item.origin_source="{ item }">
                    <span>{{ getPool(item.origin_source) }}</span>
                  </template>
                </v-data-table>
              </div>
              <v-skeleton-loader
                v-show="state && state.isLoading"
                class="mx-auto"
                min-height="500"
                type="table-tbody"
              />
            </div>
            <div>
              <v-row class="mx-0">
                <v-col
                  class="d-flex justify-center align-center px-0 py-2"
                  cols="12"
                >
                  <ais-pagination :padding="1">
                    <div
                      slot-scope="{
                        currentRefinement,
                        nbPages,
                        pages,
                        isFirstPage,
                        isLastPage,
                        refine,
                      }"
                      class="py-2 paginate"
                    >
                      <v-btn v-if="!isFirstPage" small class="mx-1" color="white" @click="refine(currentRefinement - 1)">
                        <v-icon small>mdi-chevron-left</v-icon>
                      </v-btn>
                      <v-btn v-if="!pages.includes(0)" small class="mx-1" color="white" @click="refine(0)">
                        1
                      </v-btn>
                      <v-btn v-if="nbPages > 1 && !pages.includes(1)" small disabled class="mx-1">
                        ...
                      </v-btn>
                      <v-btn v-for="page in pages" :key="page" small class="mx-1" :color="currentRefinement == page ? 'primary' : 'white'" @click="refine(page)">
                        {{ page + 1 }}
                      </v-btn>
                      <v-btn v-if="nbPages-2 > 0 && !pages.includes(nbPages - 2)" small class="mx-1" color="white" disabled>
                        ...
                      </v-btn>
                      <v-btn v-if="!pages.includes(nbPages - 1)" small class="mx-1" color="white" @click="refine(nbPages)">
                        {{ nbPages }}
                      </v-btn>
                      <v-btn v-if="!isLastPage" small class="mx-1" color="white" @click="refine(currentRefinement + 1)">
                        <v-icon small>mdi-chevron-right</v-icon>
                      </v-btn>
                    </div>
                  </ais-pagination>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </div>
      </div>
      <ContextMenu ref="contextMenu" class="contextMenu" />
    </div>
    <div
      v-if="!hasResults && state"
      class="d-flex align-start justify-center"
      style="height: calc(100vh - 155px); overflow-x: none; overflow-y: auto"
    >
      <div class="text-center">
        <img
          style="
            opacity: 0.4;
            width: 50%;
            height: 50%;
            margin-top: 5rem;
            margin-right: 3rem;
          "
          src="@/assets/robots.png"
        >
        <span class="d-block grey--text text--darken-3 text-center">Aucun résultat trouvé, voulez-vous créer un <a @click="newCustomer()">nouveau client</a></span>
      </div>
    </div>
  </div>
</template>

<script>
import 'instantsearch.css/themes/algolia-min.css';
import { createWidgetMixin } from 'vue-instantsearch';
import { utils } from '@/mixins/index';
import ContextMenu from '@/components/contents/ContextMenu.vue';

import { EventBus } from '../../mixins';
import { countries } from '../../configs/countries';

const connectGlobalState = (renderFn, unmountFn) => (widgetParams = {}) => ({
  init () {
    renderFn(
      { helper: {}, isLoading: false, isFirstPage: true, nbHits: 0, items: [] },
      true
    );
  },

  render (_ref) {
    const { helper } = _ref;
    const isLoading = _ref.searchMetadata.isSearchStalled;
    const isFirstPage = helper.state.page === 0;
    const { nbHits } = _ref.results;
    const items = _ref.results.hits;

    renderFn({ helper, isLoading, isFirstPage, nbHits, items }, false);
  },

  dispose () {
    unmountFn();
  }
});

export default {
  name: 'SearchManagerV2',
  props: { forceRenderer: Function },
  mixins: [utils, createWidgetMixin({ connector: connectGlobalState })],
  components: { ContextMenu },
  data () {
    return {
      hideSidebar: false,
      selectedItem: null,
      selectedCustomer: {},
      facets: [
        {
          show: true,
          attribute: 'town',
          label: 'Ville',
          facetType: 'refinement-list',
          facetSettings: {
            searchable: true,
            operator: 'or',
            limit: 5,
            'show-more': true,
            'show-more-limit': 20,
            'sort-by': ['count:desc']
          }
        },
        {
          show: true,
          attribute: 'zip_code',
          label: 'Code Postal',
          facetType: 'refinement-list',
          facetSettings: {
            searchable: true,
            operator: 'or',
            limit: 5,
            'show-more': true,
            'show-more-limit': 20,
            'sort-by': ['count:desc']
          }
        },
        {
          show: true,
          attribute: 'country',
          label: 'Pays',
          facetType: 'refinement-list',
          facetSettings: {
            searchable: true,
            operator: 'or',
            limit: 5,
            'show-more': true,
            'show-more-limit': 20,
            'sort-by': ['count:desc']
          }
        },
        {
          show: true,
          attribute: 'iresa_ids.extraContextInfo.type',
          label: 'Type de partenaire',
          facetType: 'refinement-list',
          facetSettings: {
            searchable: true,
            operator: 'or',
            limit: 5,
            'show-more': true,
            'show-more-limit': 20,
            'sort-by': ['count:desc']
          }
        },
        {
          show: true,
          attribute: 'iresa_ids.extraContextInfo.keyword',
          label: 'Code partenaire',
          facetType: 'refinement-list',
          facetSettings: {
            searchable: true,
            operator: 'or',
            limit: 5,
            'show-more': true,
            'show-more-limit': 20,
            'sort-by': ['count:desc']
          }
        },
        {
          show: true,
          attribute: 'iresa_ids.extraContextInfo.reference',
          label: 'Code ayant droit',
          facetType: 'refinement-list',
          facetSettings: {
            searchable: true,
            operator: 'or',
            limit: 5,
            'show-more': true,
            'show-more-limit': 20,
            'sort-by': ['count:desc']
          }
        },
        {
          show: true,
          attribute: 'contexts.label',
          label: 'Contexts',
          facetType: 'refinement-list',
          facetSettings: {
            searchable: true,
            operator: 'or',
            limit: 5,
            'show-more': true,
            'show-more-limit': 20,
            'sort-by': ['count:desc']
          }
        }
      ]
    };
  },
  computed: {
    selectedCustomers () {
      return this.$store.state.selectedCustomers;
    },
    headers () {
      const headers = [
        { text: 'Exporter vers Pégase', value: 'exportToPegase', show: this.isReturnToPegase },
        { text: 'Exporter vers Hello', value: 'exportToHello', show: this.isReturnToHello },
        { text: 'Compte digital', value: 'digital_account' },
        { text: 'Payeur', value: 'payeur' },
        { text: 'Nom', value: 'nom' },
        { text: 'DDN', value: 'birth_date' },
        { text: 'Address', value: 'address' },
        { text: 'Tél', value: 'telephone' },
        { text: 'Mobile', value: 'mobilephone' },
        { text: 'Email', value: 'email' },
        { text: 'Userpool', value: 'origin_source' },
        { text: 'Id client', value: 'uuid' }
      ];

      return headers.filter(header => !header.hasOwnProperty('show') || header.show);
    },
    isReturnToPegase () {
      return this.$store.getters.isReturnToPegase;
    },
    isReturnToHello () {
      return this.$store.getters.isReturnToHello;
    },
    countAdvancedFilters () {
      let filters = 0;
      Object.entries(this.$route.query).forEach(([key, value]) => {
        const fieldConfig = this.$store.state.advancedFieldSearchConfig.find(
          field => field.field_name === key
        );
        if (fieldConfig) {
          filters++;
        }
      });

      return filters;
    },
    resultsLabel () {
      // If has query field
      if (this.$route.query.query) {
        return `"${this.$route.query.query}"${
          this.countAdvancedFilters ? ', ' : ''
        }`;
      }

      return null;
    },
    hasResults () {
      return this.state && this.state.nbHits > 0;
    },
    customersState () {
      return this.state;
    },
    alphaWorkspace () {
      return this.$store.state.alphaWorkspace;
    }
  },
  watch: {
    customersState () {
      this.populateSelectCustomer();
    }
  },
  mounted () {
    EventBus.$on('unselectItem', this.unselectItem);
  },
  methods: {
    isCustomerPayeur (customer) {
      return customer.orderGenericBuyer || (customer.bookings && customer.bookings.length)
    },
    getPool (origin_source) {
      switch (origin_source) {
        case 'cgos':
          return 'CGOS';
        case 'cnas':
          return 'CNAS';
        case 'snous':
          return 'CNOUS';
        case '1bus1campus':
          return '1B1C';
        default:
          return 'UCPA';
      }
    },
    changeSideBar () {
      this.hideSidebar = !this.hideSidebar;
    },
    populateSelectCustomer () {
      if (this.hasResults) {
        this.state.items.map(item => {
          if ((item.customer_workspaces && item.customer_workspaces.length && item.customer_workspaces.includes(this.alphaWorkspace)) || (this.selectedCustomers.some(c => c.uuid === item.uuid))) {
            this.selectedCustomer[item.uuid] = true;
          }
        });
      }
    },
    customerSelected (event, customer) {
      event.stopPropagation();
      const selected = this.selectedCustomer[customer.uuid];

      if (selected) {
        this.$store.commit('addSelectedCustomer', customer);
        this.$store.commit('removeDeselectedCustomersCustomer', customer);
        return;
      }
      // add to deselect
      this.$store.commit('removeSelectedCustomer', customer);
      this.$store.commit('addDeselectedCustomersCustomer', customer);
    },
    getCountryLabel (flag) {
      const country = countries.find(c => c.value === flag);
      return country ? country.text : flag;
    },
    getLabel (key) {
      const fieldConfig = this.facets.find(
        field => field.attribute === key
      );

      return fieldConfig ? fieldConfig.label : key;
    },
    clickUser (item, _, event) {
      if (event && (event.ctrlKey || event.metaKey)) {
        const path = this.computePath(item);
        const route = this.$router.resolve(path);
        window.open(route.href, '_blank');
        return;
      }
      if (this.$store.state.addContactMode.active) {
        this.$store.commit('setAddContactMode', {
          active: false,
          contactToAdd: item
        });
        this.showUser(this.$store.state.addContactMode.customer_uuid);
      } else {
        this.showUser(item.uuid);
      }
    },
    rightClickUser (event, item) {
      const user = item.item;
      if (event && (event.ctrlKey || event.metaKey)) {
        const path = this.computePath(user);
        const route = this.$router.resolve(path);
        window.open(route.href, '_blank');
        return;
      }
      this.showContextMenu(event, user);
    },
    unselectItem: function () { // Unselects a row of the table
      this.selectedItem = null;
    },
    computePath (item) {
      return `/customer/${item.uuid}`;
    },
    showContextMenu (e, item) {
      // Show context menu and makes the row selected
      this.selectedItem = item;
      this.$refs.contextMenu.show(e, item);
    },
    showUser (uuid) {
      this.$router.push({
        name: 'Customer',
        params: { uuid: uuid }
      });
    },
    showAdvancedSearch () {
      EventBus.$emit('showAdvancedSearch');
    },
    transformItemsCountry (items) {
      return this.transformItemsLabel(items, 'country');
    },
    transformItemsLabel (items, attribute) {
      const itemsTransformed = items.map(item => {
        // console.log(item);
        if (attribute === 'country') {
          item.highlighted = this.getCountryLabel(item.highlighted);
          item.label = this.getCountryLabel(item.label);
        }
        return item;
      });

      return itemsTransformed;
    },
    transformItems (items) {
      // Changes all the labels of current refinement
      items = items.map(item => {
        if (item.attribute === 'country') {
          item.refinements = this.transformItemsLabel(item.refinements, 'country');
        }

        return {
          ...item,
          label: this.getLabel(item.attribute)
        };
      });
      return items.reverse();
    },
    classNames: function (component) {
      // Gets the right style of the refinement widget
      switch (component) {
        case 'ais-menu':
          return {
            'ais-Menu-label': 'ais-label-custom',
            'ais-Menu-count': 'ais-count-custom',
            'ais-Menu-item': 'ais-item-custom',
            'ais-Menu-item--selected': 'ais-item--selected-custom'
          };
        case 'ais-refinement-list':
          return {
            'ais-RefinementList-label': 'ais-RefinementList-label-custom',
            'ais-RefinementList-count': 'ais-count-custom',
            'ais-RefinementList-item': 'ais-item-custom',
            'ais-RefinementList-item--selected': 'ais-item--selected-custom',
            'ais-RefinementList-checkbox': 'ais-checkbox',
            'ais-RefinementList-noResults': 'ais-noResults',
            'ais-RefinementList-showMore--disabled': 'ais-showMore--disabled',
            'ais-RefinementList-searchBox': 'ais-searchBox'
          };
        case 'ais-hierarchical-menu':
          return {
            'ais-HierarchicalMenu-label': 'ais-label-custom',
            'ais-HierarchicalMenu-count': 'ais-count-custom',
            'ais-HierarchicalMenu-item': 'ais-item-custom',
            'ais-HierarchicalMenu-item--selected': 'ais-item--selected-custom'
          };
      }
    }
  }
};
</script>

<style lang="scss">
.breadcrumbs {
  min-height: 40px;
}
.sidebar {
  width: 330px;
  height: calc(100vh - 185px);
  overflow-x: hidden;
  overflow-y: scroll;
}
.content {
  width: calc(100% - 330px);
}
.results {
  max-height: calc(100vh - 275px);
  overflow-x: hidden;
  overflow-y: scroll;
}
.ais-SearchBox-input {
  background-color: #fff;
  border: 1px solid #d8c4c4;
}
.ais-SearchBox-resetIcon path,
.ais-SearchBox-submitIcon path {
  fill: #884949;
}

.ais-Breadcrumb,
.ais-ClearRefinements,
.ais-CurrentRefinements,
.ais-GeoSearch,
.ais-HierarchicalMenu,
.ais-Hits,
.ais-HitsPerPage,
.ais-InfiniteHits,
.ais-InfiniteResults,
.ais-Menu,
.ais-MenuSelect,
.ais-NumericMenu,
.ais-NumericSelector,
.ais-Pagination,
.ais-Panel,
.ais-PoweredBy,
.ais-RangeInput,
.ais-RangeSlider,
.ais-RatingMenu,
.ais-RefinementList,
.ais-Results,
.ais-ResultsPerPage,
.ais-SearchBox,
.ais-SortBy,
.ais-Stats,
.ais-ToggleRefinement {
  color: rgba(0, 0, 0, 0.87);
}
.ais-HierarchicalMenu-count,
.ais-Menu-count,
.ais-RefinementList-count,
.ais-ToggleRefinement-count {
  color: #703a3a;
  background-color: #eedfdf;
}
.ais-RefinementList {
  text-align: right;
}
.ais-RefinementList-list {
  text-align: left;
  padding-left: 0 !important;
  color: #000;
}
.ais-RefinementList-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.1rem 0.5rem;
}
.ais-RefinementList-labelText {
  width: 78%;
  height: 20px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ais-RefinementList-showMore {
  text-decoration: underline;
  margin-top: 1rem;
  &:focus {
    background-color: transparent;
    color: #333;
  }
}
.ais-RefinementList-showMore[disabled] {
  display: none;
}
.ais-ClearRefinements-button:focus {
  background-color: #dddddd88;
}
.ais-RefinementList-showMore,
.ais-ClearRefinements-button {
  background-color: transparent;

  color: red;
  &:hover {
    background-color: transparent;

    color: red;
    &:hover {
      background-color: transparent;
      color: #333;
    }
    &:focus {
      background-color: transparent;
      color: #333;
    }
    .ais-CurrentRefinements-list {
      li {
        margin-right: 2rem;
      }
    }
  }
}
.ais-ClearRefinements-button--disabled {
  display: none !important;
}
.lightblue {
  background-color: #dfe2ee !important;
}
a {
  color: red;
  text-decoration: underline;
}
.ais-RefinementList-item {
  position: relative;
  input[type="checkbox"] {
    line-height: 2.1ex;
  }
  input[type="radio"],
  input[type="checkbox"] {
    position: absolute;
    left: -999rem;
  }
  label::before {
    content: "";
    display: inline-block;
    vertical-align: -25%;
    height: 2ex;
    width: 2ex;
    border: 1px solid rgb(166, 166, 166);
    border-radius: 4px;
    box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.25);
    margin-right: 0.5em;
  }
}
.ais-RefinementList-item--selected {
  label::after {
    content: "";
    position: absolute;
    width: 10px;
    height: 5px;
    background: rgba(0, 0, 0, 0);
    top: 9px;
    left: 11px;
    border: 3px solid white;
    border-top: none;
    border-right: none;
    transform: rotate(-45deg);
  }
  label::before {
    content: "";
    border: 1px solid red;
    background-color: red;
  }
}
.ais-Pagination {
  ul li {
    padding: 1rem;
    display: inline-block;
  }
}
.paginate {
  .v-btn:not(.v-btn--round).v-size--small {
    height: 28px;
    min-width: 38px;
    padding: 0 12.4444444444px;
}
}
.pointer {
  cursor: pointer;
}
</style>
